module.exports = __webpack_public_path__ + "static/media/70861.a9ad48a7.JPG";